export const getMerchantPspCode = (merchantSetupOption: string) => {
  const startIndex = merchantSetupOption.lastIndexOf('(');
  const endIndex = merchantSetupOption.lastIndexOf(')');

  if (startIndex !== -1 && endIndex !== -1)
    return merchantSetupOption.substring(startIndex + 1, endIndex);

  return undefined;
};
